import {get} from "../../api"
import * as url from "../../url"

const apiGetEnumPermissionsList = data => {
  return get(url.API_ENUM_PERMISSIONS, data.history)
}

export {
  apiGetEnumPermissionsList,
}
